<template>
    <div class="findSupplier relative">
        <div class='autocompleteel'> 
            <!-- <div class="form-row"> -->
                <vs-input type="text" label="Proveedor" v-model="searchText" @keyup='loadSuggestions()'/>
                <div class='suggestionlist' v-if="suggestiondata.length">
                    <ul> 
                        <li v-for='(item,index) in suggestiondata' @click='itemSelected(index)' :key="index">  {{ item.NAME }} </li> 
                    </ul>
                </div> 
            <!-- </div> -->
        </div>
    </div>
</template>
<script>
import CatalogService from '@/services/CatalogService'
export default {
    name: "findSupplierComp",
    props: {
        openSuggestions: { type: Boolean, default: false},
        keepSearch: { type: Boolean, default: false},
        flagType: { type: String, default: "Supplier"}
    },
    data () {
        return {
            searchText: "",
            suggestiondata: [],
        }
    },
    watch: {
        openSuggestions(val){
            if(!val){
                if(!this.keepSearch){
                    this.searchText = ''
                }
                this.suggestiondata = [];
            }
        }
    },
    methods: {
        async loadSuggestions(){
            this.suggestiondata = [];
            let response;
            if(this.flagType == 'Supplier'){
                response = await CatalogService.getSuppliers({ search: this.searchText});
            } else {
                response = await CatalogService.getAgencies({ search: this.searchText});
            }
            if((response.status/100) == 2){
                this.suggestiondata = response.data
            }
        },
        itemSelected(index){
            this.$emit('supplier', this.suggestiondata[index])
            if(!this.keepSearch){
                this.searchText = ""
            } else {
                this.searchText = this.suggestiondata[index].NAME
            }
            this.suggestiondata = [];
        },
    }

}
</script>